import React from "react";
import { BaseResourceAndDownloadsProps } from "./types";
import PdpResourcesAndDownloads from "./variants/PdpResourcesAndDownloads";
import PlpResourcesAndDownloads from "./variants/PlpResourcesAndDownloads";

interface ResourcesAndDownloadsTwoProps extends BaseResourceAndDownloadsProps {
  variant: string;
}

const ResourcesAndDownloads = (props: ResourcesAndDownloadsTwoProps) => {
  const { variant, ...rest } = props;

  switch (variant) {
    case "pdp":
      return <PdpResourcesAndDownloads {...rest} />;
    case "plp":
      return <PlpResourcesAndDownloads {...rest} />;
    default:
      return null;
  }
};

export default ResourcesAndDownloads;
